import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkedAccounts from '../components/LinkedAccounts';
export default function addLinkedAccountsToUserSecurityPage() {
  extend('flarum/forum/components/UserSecurityPage', 'settingsItems', function (items) {
    if (this.user?.id() !== app.session.user?.id() && !app.forum.attribute('fofOauthModerate')) {
      return;
    }
    items.add('linkedAccounts', m(LinkedAccounts, {
      user: this.user
    }), 5);
  });
}
flarum.reg.add('fof-oauth', 'forum/extenders/addLinkedAccountsToUserSecurityPage', addLinkedAccountsToUserSecurityPage);